import { actionTypes } from "./booked-appoinments-rating.action";

export interface IBookedAppointmentsRatingState {
  starRating: number | string;
  stepOneFeedback: string;
};

const initialState: IBookedAppointmentsRatingState = {
  starRating: 0,
  stepOneFeedback: "",
};

export const bookedAppointmentsRatingReducer = (
  state: IBookedAppointmentsRatingState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_APPOINTMENT_STAR_RATING:
    return {
      ...state,
      starRating: action.payload,
    };
  case actionTypes.SET_APPOINTMENT_STEP_ONE_FEEDBACK:
    return {
      ...state,
      stepOneFeedback: action.payload,
    };
  case actionTypes.SET_APPOINTMENT_RATING_NULL:
    return {
      ...state,
      starRating: 0,
      stepOneFeedback: "",
    };
  default:
    return state;
  }
};
